import React from 'react';
import {Flex} from "antd";
import {HydraAdmin, ListGuesser, ResourceGuesser} from "@api-platform/admin";
import ProductsList from '../../components/admin/Products/List'
import ProductsEdit from '../../components/admin/Products/Edit'
import ProductsShow from '../../components/admin/Products/Show'
import ProductsCreate from '../../components/admin/Products/Create'

import CompaniesList from '../../components/admin/Companies/List'
import CompaniesEdit from '../../components/admin/Companies/Edit'
import CompaniesShow from '../../components/admin/Companies/Show'
import CompaniesCreate from '../../components/admin/Companies/Create'

import PoolsList from '../../components/admin/WithMpmId/List'
import PoolsEdit from '../../components/admin/WithMpmId/Edit'
import PoolsShow from '../../components/admin/WithMpmId/Show'
import PoolsCreate from '../../components/admin/WithMpmId/Create'

import EfficiencyMetricsList from '../../components/admin/WithForeignId/List'
import EfficiencyMetricsEdit from '../../components/admin/WithForeignId/Edit'
import EfficiencyMetricsShow from '../../components/admin/WithForeignId/Show'
import EfficiencyMetricsCreate from '../../components/admin/WithForeignId/Create'

import KpiList from '../../components/admin/Kpi/List'
import KpiEdit from '../../components/admin/Kpi/Edit'
import KpiShow from '../../components/admin/Kpi/Show'
import KpiCreate from '../../components/admin/Kpi/Create'

import ModelTypeList from '../../components/admin/ModelType/List'
import ModelTypeEdit from '../../components/admin/ModelType/Edit'
import ModelTypeShow from '../../components/admin/ModelType/Show'
import ModelTypeCreate from '../../components/admin/ModelType/Create'

import MetricsList from '../../components/admin/WithForeignId/List'
import MetricsEdit from '../../components/admin/WithForeignId/Edit'
import MetricsShow from '../../components/admin/WithForeignId/Show'
import MetricsCreate from '../../components/admin/WithForeignId/Create'

import ModelFileTypeList from '../../components/admin/ModelFileType/List'
import ModelFileTypeEdit from '../../components/admin/ModelFileType/Edit'
import ModelFileTypeShow from '../../components/admin/ModelFileType/Show'
import ModelFileTypeCreate from '../../components/admin/ModelFileType/Create'

import MediaList from '../../components/admin/WithCode/List'
import MediaEdit from '../../components/admin/WithCode/Edit'
import MediaShow from '../../components/admin/WithCode/Show'
import MediaCreate from '../../components/admin/WithCode/Create'

import ChannelsList from '../../components/admin/Channels/List'
import ChannelsEdit from '../../components/admin/Channels/Edit'
import ChannelsShow from '../../components/admin/Channels/Show'
import ChannelsCreate from '../../components/admin/Channels/Create'

import CriterionTypeList from '../../components/admin/WithCode/List'
import CriterionTypeEdit from '../../components/admin/WithCode/Edit'
import CriterionTypeShow from '../../components/admin/WithCode/Show'
import CriterionTypeCreate from '../../components/admin/WithCode/Create'

import StageTypeList from '../../components/admin/StageTypes/List'
import StageTypeEdit from '../../components/admin/StageTypes/Edit'
import StageTypeShow from '../../components/admin/StageTypes/Show'
import StageTypeCreate from '../../components/admin/StageTypes/Create'

import TaskStatusesList from '../../components/admin/WithName/List'
import TaskStatusesEdit from '../../components/admin/WithName/Edit'
import TaskStatusesShow from '../../components/admin/WithName/Show'
import TaskStatusesCreate from '../../components/admin/WithName/Create'

import TaskTypesList from '../../components/admin/WithCode/List'
import TaskTypesEdit from '../../components/admin/WithCode/Edit'
import TaskTypesShow from '../../components/admin/WithCode/Show'
import TaskTypesCreate from '../../components/admin/WithCode/Create'

import BriefGroupTypesList from '../../components/admin/WithName/List'
import BriefGroupTypesEdit from '../../components/admin/WithName/Edit'
import BriefGroupTypesShow from '../../components/admin/WithName/Show'
import BriefGroupTypesCreate from '../../components/admin/WithName/Create'

import {apiDocumentationParser, fetchHydra} from "../../components/admin/documentParser";
import useAuthProvider from "../../components/admin/authProvider";
import customDataProvider from "../../components/admin/dataProvider";
import {t} from "i18next";

export default function AdminPanel() {
    const authProvider = useAuthProvider()
    const entrypoint = process.env.REACT_APP_API_ENTRYPOINT;

    const dataProvider = customDataProvider({
        entrypoint,
        httpClient: fetchHydra,
        apiDocumentationParser,
        mercure: true,
        useEmbedded: false,
    });

    return (
        <Flex style={{width: '100%'}} className={'admin-panel'}>
            <HydraAdmin
                authProvider={authProvider}
                dataProvider={dataProvider}
                entrypoint={entrypoint}
                mercure={false}
                style={{width: '100%'}}
            >
                <ResourceGuesser
                    name="dictionary/pool_companies"
                    list={PoolsList}
                    create={PoolsCreate}
                    edit={PoolsEdit}
                    show={PoolsShow}
                    options={{
                        label: t('admin.pools'),
                    }}
                />
                <ResourceGuesser
                    name="dictionary/companies"
                    list={CompaniesList}
                    create={CompaniesCreate}
                    edit={CompaniesEdit}
                    show={CompaniesShow}
                    options={{
                        label: t('admin.clients'),
                    }}
                />
                <ResourceGuesser
                    name="dictionary/products"
                    list={ProductsList}
                    create={ProductsCreate}
                    edit={ProductsEdit}
                    show={ProductsShow}
                    options={{
                        label: t('admin.products'),
                    }}
                />
                <ResourceGuesser
                    name="dictionary/efficiency_metrics"
                    list={EfficiencyMetricsList}
                    create={EfficiencyMetricsCreate}
                    edit={EfficiencyMetricsEdit}
                    show={EfficiencyMetricsShow}
                    options={{
                        label: t('admin.efficiencyMetrics'),
                    }}
                />
                <ResourceGuesser
                    name="dictionary/kpis"
                    list={KpiList}
                    create={KpiCreate}
                    edit={KpiEdit}
                    show={KpiShow}
                    options={{
                        label: t('admin.kpiNumber'),
                    }}
                />
                <ResourceGuesser
                    name="dictionary/model_types"
                    list={ModelTypeList}
                    create={ModelTypeCreate}
                    edit={ModelTypeEdit}
                    show={ModelTypeShow}
                    options={{
                        label: t('admin.modelType'),
                    }}
                />
                <ResourceGuesser
                    name="dictionary/metrics/"
                    list={MetricsList}
                    create={MetricsCreate}
                    edit={MetricsEdit}
                    show={MetricsShow}
                    options={{
                        label: t('admin.metrics'),
                    }}
                />
                <ResourceGuesser
                    name="dictionary/model_file_types"
                    list={ModelFileTypeList}
                    create={ModelFileTypeCreate}
                    edit={ModelFileTypeEdit}
                    show={ModelFileTypeShow}
                    options={{
                        label: t('admin.modelFileType'),
                    }}
                />
                <ResourceGuesser
                    name="dictionary/medias"
                    list={MediaList}
                    create={MediaCreate}
                    edit={MediaEdit}
                    show={MediaShow}
                    options={{
                        label: t('admin.media'),
                    }}
                />
                <ResourceGuesser
                    name="dictionary/channels"
                    list={ChannelsList}
                    create={ChannelsCreate}
                    edit={ChannelsEdit}
                    show={ChannelsShow}
                    options={{
                        label: t('admin.channels'),
                    }}
                />
                <ResourceGuesser
                    name="dictionary/criterion_types"
                    list={CriterionTypeList}
                    create={CriterionTypeCreate}
                    edit={CriterionTypeEdit}
                    show={CriterionTypeShow}
                    options={{
                        label: t('admin.criterionTypes'),
                    }}
                />
                <ResourceGuesser
                    name="dictionary/stage_types"
                    list={StageTypeList}
                    create={StageTypeCreate}
                    edit={StageTypeEdit}
                    show={StageTypeShow}
                    options={{
                        label: t('admin.stageTypes'),
                    }}
                />
                <ResourceGuesser
                    name="dictionary/task_statuses"
                    list={TaskStatusesList}
                    create={TaskStatusesCreate}
                    edit={TaskStatusesEdit}
                    show={TaskStatusesShow}
                    options={{
                        label: t('admin.taskStatuses'),
                    }}
                />
                <ResourceGuesser
                    name="dictionary/task_types"
                    list={TaskTypesList}
                    create={TaskTypesCreate}
                    edit={TaskTypesEdit}
                    show={TaskTypesShow}
                    options={{
                        label: t('admin.taskTypes'),
                    }}
                />
                <ResourceGuesser
                    name="dictionary/brief_group_types"
                    list={BriefGroupTypesList}
                    create={BriefGroupTypesCreate}
                    edit={BriefGroupTypesEdit}
                    show={BriefGroupTypesShow}
                    options={{
                        label: t('admin.briefGroupTypes'),
                    }}
                />
            </HydraAdmin>
        </Flex>
    )
}
